<template>
  <q-btn
      v-bind="$attrs"
      :color="color"
      :dense="dense"
      :size="size"
      :round="round"
      :aria-label="ariaLabel"
      class="btn btn__icon"
      padding="sm"
      :flat="!outline"
      :outline="outline"
  >
    <q-tooltip class="bg-neutral-80 text-white" anchor="top middle" self="bottom middle" :offset="[10, 10]">
      {{ ariaLabel }}
    </q-tooltip>
    <q-badge v-if="hasNotifications" color="red" rounded floating />
    <slot />
  </q-btn>
</template>

<script>
export default {
  props: {
    ariaLabel: {
      type: String,
      required: true
    },
    round: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'neutral-40'
    },
    size: {
      type: String,
      default: 'md'
    },
    hasNotifications: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    }
  }
}
</script>
